import { useCallback } from 'react';
import { AccountPermission } from '../types';
import { isInSaaSMode } from '../utils/common';
import useAccount from './useAccount';

const useAccountPermission = () => {
  const { data } = useAccount();

  const hasPermission = useCallback(
    (permission: AccountPermission) => {
      if (!isInSaaSMode()) {
        return true;
      }
      return !!data?.permissions?.includes(permission);
    },
    [data],
  );

  return hasPermission;
};

export default useAccountPermission;
